export const isMobileView = () => {
  return document.body.offsetWidth <= 600;
};
